export default __webpack_public_path__ + "static/media/Error.c9ff5c1b.svg";